import { create } from 'zustand';


type RoundStatus = 'waiting' | 'active' | 'results'

type GameStateStore = {
  pickedNumbers: number[]
  roundStatus: RoundStatus
  winnerCardId: number
  countdown: number
  setGameState: (roundStatus: RoundStatus, countdown: number, winnerCardId: number) => void

}

export const useGameStateStore = create<GameStateStore>((set, get) => ({
  pickedNumbers: [],
  roundStatus: "active",
  winnerCardId: -1,
  countdown: 0,
  setGameState: (roundStatus, countdown, winnerCardId) => {
    set({ roundStatus, countdown, winnerCardId })
  }

}))